import axios from 'axios'
import library from '../../../utils/Library'

export const getAllSuborganizationCorpEntities = async (orgId) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL =
    library.getBaseAPIUrl('suborganizations') +
    '/getAllSuborganizationCorpEntities'

  return await axios.get(URL, {
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    params: {
      organizationId: orgId,
      suborganizationTypeCode: 'ORG-FIRM'
    }
  })
}
